import { AppliedFilterInterface, BlockStack, FilterInterface, TextField } from '@shopify/polaris'
import { useCallback } from 'react'

import { SubscriptionFilter } from '../api'

const parseCount = (value: string): number | undefined => {
  if (value === '') {
    return undefined
  }
  const parsed = parseInt(value)
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : undefined
}

const formatBound = (value: number | undefined): string =>
  value === undefined ? '' : String(value)

const rangeLabel = (min: number | undefined, max: number | undefined): string | null => {
  if (min !== undefined && max !== undefined) {
    return `${min} – ${max}`
  }
  if (min !== undefined) {
    return `≥ ${min}`
  }
  if (max !== undefined) {
    return `≤ ${max}`
  }
  return null
}

export const useAddSuccessfulPaymentsFilter = (
  filter: SubscriptionFilter,
  updateFilter: (newFilter: Partial<SubscriptionFilter>) => any,
  filters: FilterInterface[],
  appliedFilters: AppliedFilterInterface[]
) => {
  const setMin = useCallback(
    (value: string) =>
      updateFilter({
        processed_installments_min: parseCount(value),
      }),
    [updateFilter]
  )

  const setMax = useCallback(
    (value: string) =>
      updateFilter({
        processed_installments_max: parseCount(value),
      }),
    [updateFilter]
  )

  filters.push({
    key: 'successful_payments',
    label: 'Successful payments',
    filter: (
      <BlockStack gap="100">
        <TextField
          label="Minimum"
          type="number"
          min={0}
          step={1}
          autoComplete="off"
          value={formatBound(filter.processed_installments_min)}
          onChange={setMin}
          placeholder="Min"
        />
        <TextField
          label="Maximum"
          type="number"
          min={0}
          step={1}
          autoComplete="off"
          value={formatBound(filter.processed_installments_max)}
          onChange={setMax}
          placeholder="Max"
        />
      </BlockStack>
    ),
  })

  const range = rangeLabel(filter.processed_installments_min, filter.processed_installments_max)
  if (range !== null) {
    appliedFilters.push({
      key: 'successful_payments',
      label: `Successful payments: ${range}`,
      onRemove: () =>
        updateFilter({
          processed_installments_min: undefined,
          processed_installments_max: undefined,
        }),
    })
  }
}
